import React, { useState } from "react";
import Kitoblar from "./Menular/Kitoblar";
import Telefonlar from "./Menular/Telefonlar";
import { Icon } from "@mui/material";
import {
  MenuBook as MenuBookIcon,
  DevicesOther as DevicesOtherIcon,
  Home as HomeIcon,
  AcUnit as AcUnitIcon,
  Computer as ComputerIcon,
  SportsBasketball as SportsBasketballIcon,
  Kitchen as KitchenIcon,
  Tv as TvIcon,
  SportsEsports as SportsEsportsIcon,
  Chair as ChairIcon,
  Dns as DnsIcon,
  Spa as SpaIcon,
  ChildFriendly as ChildFriendlyIcon,
  ShoppingBag as ShoppingBagIcon,
  Toys as ToysIcon,
  DriveEta as DriveEtaIcon,
} from "@mui/icons-material";

import Maishiy from "./Menular/Maishiy";
import Iqlim from "./Menular/Iqlim";
import Geymerlar from "./Menular/Geymerlar";
import Mebel from "./Menular/Mebel";
import Sport from "./Menular/Sport";
import Televizorlar from "./Menular/Televizorlar";
import UyOfis from "./Menular/UyOfis";
import Kompyuter from "./Menular/Kompyuter";
import AvtoMollar from './Menular/AvtoMollar';
import IdishTovoqlar from './Menular/IdishTovoqlar';
import Gozallik from './Menular/Gozallik';
import Bolalar from './Menular/Bolalar';
import Kiyimlar from './Menular/Kiyimlar';
import Oyinchoqlar from './Menular/Oyinchoqlar';


const sidebarItems = [
  { icon: MenuBookIcon, title: "Kitoblar" },
  { icon: DevicesOtherIcon, title: "Telefon va Gadjetlar" },
  { icon: HomeIcon, title: "Maishiy texnika" },
  { icon: AcUnitIcon, title: "Iqlim texnikasi" },
  { icon: ComputerIcon, title: "Kompyuter texnikasi" },
  { icon: SportsBasketballIcon, title: "Sport va dam olish" },
  { icon: KitchenIcon, title: "Uy va ofis uchun texnika va jihozlar" },
  { icon: TvIcon, title: "Televizorlar, video va audio" },
  { icon: SportsEsportsIcon, title: "Geymerlar uchun tovarlar" },
  { icon: ChairIcon, title: "Mebel" },
  { icon: DnsIcon, title: "Idish - tovoqlar" },
  { icon: SpaIcon, title: "Go'zallik va salomatlik" },
  { icon: ChildFriendlyIcon, title: "Bolalar uchun tovarlar" },
  { icon: ShoppingBagIcon, title: "Kiyim, poyabzal va aksessuarlar" },
  { icon: ToysIcon, title: "O'yinchoqlar, sovg'alar va aksessuarlar" },
  { icon: DriveEtaIcon, title: "Avto mollari" },
];

function SideBar() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleMouseEnter = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className="z-0 flex">
      <div className="py-4 bg-whiteSmoke shadow-lg sm:w-72 md:w-80 lg:w-96 overflow-y-scroll h-[600px]">
        <style>
          {`
      .overflow-y-scroll::-webkit-scrollbar {
        width: 4px;
      }

      .overflow-y-scroll::-webkit-scrollbar-thumb {
        background-color: #a5a5a5;
        border-radius: 3px;
      }

      .overflow-y-scroll::-webkit-scrollbar-track {
        background-color: #f1f1f1;
      }
    `}
        </style>
        <ul className="space-y-2 font-medium flex flex-col justify-center items-center">
          {sidebarItems.map((item, index) => (
            <li className="w-full" key={index}>
              <a
                href="#"
                className={`leading-6 py-1 px-4 hover:bg-white flex w-full transition duration-200 ease-in sm:text-sm md:text-base lg:text-lg xl:text-xl`}
                onMouseEnter={() => handleMouseEnter(index)}
                style={{ color: activeIndex === index ? "#008DFF" : "#212529", backgroundColor: activeIndex === index ? "white" : "#F8F8F8"}}
              >
                <Icon
                  component={item.icon}
                  className="mr-3"
                  fontSize="medium"
                />
                {item.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="w-full">
        {activeIndex === 0 && <Kitoblar />}
        {activeIndex === 1 && <Telefonlar />}
        {activeIndex === 2 && <Maishiy />}
        {activeIndex === 3 && <Iqlim />}
        {activeIndex === 4 && <Kompyuter />}
        {activeIndex === 5 && <Sport />}
        {activeIndex === 6 && <UyOfis />}
        {activeIndex === 7 && <Televizorlar />}
        {activeIndex === 8 && <Geymerlar />}
        {activeIndex === 9 && <Mebel />}
        {activeIndex === 10 && <IdishTovoqlar/>}
        {activeIndex === 11 && <Gozallik/>}
        {activeIndex === 12 && <Bolalar/>}
        {activeIndex === 13 && <Kiyimlar/>}
        {activeIndex === 14 && <Oyinchoqlar/>}
        {activeIndex === 15 && <AvtoMollar/>}
      </div>
    </div>
  );
}

export default SideBar;
